<template>
  <a-radio-group v-model="locale" button-style="solid" class="header_radio">
    <a-radio-button value="zh">zh</a-radio-button>
    <a-radio-button value="en">en</a-radio-button>
  </a-radio-group>
</template>

<script>
export default {
  data() {
    return {
      locale: "",
    };
  },
  mounted() {
    this.locale = localStorage.getItem("locale") || "zh";
  },
  inject: ["reload"],
  watch: {
    locale: {
      handler(val, oldVal) {
        if (val != oldVal && oldVal != "") {
          localStorage.setItem("locale", val);
          this.reload();
        }
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/todoCenter/lang.vue